import React from 'react'
import './styles.css'
// libs
import { useForm } from 'react-hook-form'
import { motion, AnimatePresence } from 'framer-motion'
import { XMarkIcon } from '@heroicons/react/24/outline'
// components
import Input from '../../../../ui/Input/input'
// constants
import { BACKEND_URL } from '../../../../../constants/env'
import { REFERRAL_CLOSED } from '../../../../../constants/mwm'

const modalVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
  exit: { opacity: 0, transition: { duration: 0.5 } },
}

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0, transition: { duration: 0.5 } },
}

const SourceModal = ({ isOpen, onClose }) => {
  const [submitError, setSubmitError] = React.useState(false)

  const handleCloseModal = () => {
    localStorage.setItem('referrer', REFERRAL_CLOSED)
    onClose()
  }

  const handleFormSubmit = async (formData) => {
    try {
      if (!formData.agreement) {
        throw new Error('Error submitting form')
      }

      const requestBody = {
        referrer: formData.info,
      }

      const response = await fetch(`${BACKEND_URL}/api/landings/mwm/referrer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      })

      if (!response.ok) {
        throw new Error('Error submitting form')
      }

      reset()
      handleCloseModal()
    } catch (error) {
      setSubmitError(true)
    }
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm()

  const handleContentClick = (e) => {
    e.stopPropagation()
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className='mwm-modal-overlay'
          variants={overlayVariants}
          initial='hidden'
          animate='visible'
          exit='exit'
          onClick={handleCloseModal}
          transition={{ duration: 0.2 }}
        >
          <motion.form
            className='mwm-modal-content'
            variants={modalVariants}
            initial='hidden'
            animate='visible'
            exit='exit'
            onClick={handleContentClick}
            transition={{ duration: 0.2, delay: 0.1 }}
            onSubmit={handleSubmit(handleFormSubmit)}
          >
            <button
              type='button'
              className='mwm-modal-close-button'
              onClick={onClose}
              aria-label='Close modal'
            >
              <XMarkIcon className='mwm-modal-close-icon' />
            </button>

            <div className={'mwm-title-message'}>
              Which non-profit organization(s) referred you to the Afghan
              Women's Economic Resilience (AWER) program?
            </div>

            <div className={'mwm-source-modal-input-wrapper'}>
              <Input
                id='info'
                type='text'
                register={register}
                validation={{ required: 'Organization is required' }}
                errors={errors}
                watch={watch}
              />
            </div>
            <div className={'mwm-checkbox-wrapper'}>
              <label className='mwm-checkbox-label' htmlFor={'agreement'}>
                <input
                  type={'checkbox'}
                  id={'agreement'}
                  className={'mwm-checkbox'}
                  {...register('agreement', {
                    required: true,
                  })}
                />
                <span className={'mwm-checkbox-label-text'}>
                  AWER mentors provide general information only and do not
                  provide any advice, assistance, or services related to
                  resettlement, relocation, or evacuation. AWER mentors are not,
                  by means of this mentorship program, rendering accounting,
                  business, financial, investment, legal, tax, or other
                  professional advice or services. This mentorship is not a
                  substitute for such professional advice or services, nor
                  should it be used as a basis for any decision or action that
                  may affect your business. Before making any decision or taking
                  any action that may affect your business, you should consult a
                  qualified professional advisor. AWER mentors shall not be
                  responsible for any loss sustained by any person who relies on
                  this mentorship relationship.
                  <span className={'checkbox-label-required'}>*</span>
                </span>
              </label>
              {errors['agreement'] && (
                <span className='error'>
                  Please complete this required field.
                </span>
              )}
            </div>

            {submitError && (
              <p className='error-message'>
                An error occurred while submitting the form. Please try again.
              </p>
            )}

            <button type='submit' className='mwm-modal-submit-button'>
              Submit
            </button>
          </motion.form>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default SourceModal
